import { TemperatureScales } from "./temperature-value";
import { TemperatureConverter } from "./temperature-value";

export class TemperatureDeltaValueConverter {
    toView(value: number): number {

        let temperatureScale = localStorage.getItem("temperature-scale");
        if (!temperatureScale) {
            temperatureScale = TemperatureScales.fahrenheit;
        }

        switch (temperatureScale) {
        case TemperatureScales.celsius:
            return value;
        default:
            return TemperatureConverter.toFahrenheit(value);
        }
	}
}